import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M5.75 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m-2.109 8.641A4.75 4.75 0 0 1 7 14.25h7A4.75 4.75 0 0 1 18.75 19v2a.75.75 0 0 1-1.5 0v-2A3.25 3.25 0 0 0 14 15.75H7A3.25 3.25 0 0 0 3.75 19v2a.75.75 0 0 1-1.5 0v-2c0-1.26.5-2.468 1.391-3.359m16.642-6.988a.75.75 0 0 1 .75.75v1.13h1.13a.75.75 0 0 1 0 1.5h-1.13v1.13a.75.75 0 1 1-1.5 0v-1.13h-1.13a.75.75 0 1 1 0-1.5h1.13v-1.13a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }